export default {
      id: "saveAlt-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#saveAlt-usage",
      toString: function () {
        return this.url;
      }
    }